import { useReducer } from "react";

export interface CollapsibleState {
  collapsed: boolean;
  toggleCollapsed: () => void;
}

export const useCollapsible = (initialCollapsed: boolean): CollapsibleState => {
  const [collapsed, toggleCollapsed] = useReducer(s => !s, Boolean(initialCollapsed));

  return {
    collapsed,
    toggleCollapsed,
  };
};
